function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.7 10H4.3c-.7 0-1.3.6-1.3 1.3v1.3c0 .8.6 1.4 1.3 1.4h15.4c.7 0 1.3-.6 1.3-1.3v-1.3c0-.8-.6-1.4-1.3-1.4z"
}));